module.exports = __webpack_public_path__ + "img/3.df6a8841.png";